import { Typography } from '@/components/ui/typography'
import { OGSM_COPY } from '@/features/ogsm/ogsm-labels'
import type { OgsmBoardNode } from '@/types/api'

export function OwnerChip({ node }: { node: OgsmBoardNode }) {
  const { owner } = node
  return (
    <span
      title={owner?.name ?? OGSM_COPY.unassigned}
      className="inline-flex h-5.5 min-w-7 shrink-0 px-1 items-center justify-center rounded-md border border-primary/20 bg-primary/5"
    >
      <Typography as="span" variant="body-sm" className="font-semibold">
        {owner?.initials ?? '–'}
      </Typography>
    </span>
  )
}
